import { render } from "./company-data-collector-register.vue?vue&type=template&id=1129a8df&ts=true"
import script from "./company-data-collector-register.vue?vue&type=script&lang=ts"
export * from "./company-data-collector-register.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__